module.exports = __webpack_public_path__ + "img/2.3d1f8f72.png";